// Custom components
import React from "react";

function TextField(props) {
  const {
    label,
    id,
    extra,
    placeholder,
    cols,
    rows,
    state,
    disabled,
    onChange,
    errors,
    name,
    register,
    validationSchema,
    defaultValue,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`ml-1.5 text-sm font-medium text-navy-700
          dark:text-white`}
        dangerouslySetInnerHTML={{
          __html: label.includes("*")
            ? label.split("*")[0] + `<span class='text-red-500'>*</span>`
            : label,
        }}
      ></label>
      <div>
        <textarea
          cols={cols}
          rows={rows}
          defaultValue={defaultValue}
          // required={label.includes("*") ? true : false}
          placeholder={placeholder}
          className={`flex w-full items-center justify-center rounded-xl border bg-white/0 pl-3 pt-3 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
              ? "!border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "!border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : "border-gray-200 dark:!border-white/10 dark:text-white"
          } ${extra}`}
          name={id}
          id={id}
          onChange={onChange}
          {...register(name, validationSchema)}
        />
        {errors &&
          (errors[name]?.type === "required" ||
            errors[name]?.type === "minLength" ||
            errors[name]?.type === "maxLength" ||
            errors[name]?.type === "pattern" ||
            errors[name]?.type === "validate") && (
            <span className="error text-red-500">{errors[name]?.message}</span>
          )}
        {/* {errors && errors[name]?.type === "required" && (
          <span className="error text-red-500">{errors[name]?.message}</span>
        )}
        {errors && errors[name]?.type === "minLength" && (
          <span className="error text-red-500">{errors[name]?.message}</span>
        )} */}
      </div>
    </div>
  );
}

export default TextField;
